"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUsersItem = exports.convertWorkspaceUser = exports.convertUser = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var getUserFullName = function (firstName, lastName) {
    if (!firstName && !lastName) {
        return undefined;
    }
    return [firstName, lastName].filter(Boolean).join(" ");
};
exports.convertUser = function (user) {
    var email = user.email, login = user.login, firstName = user.firstName, lastName = user.lastName, links = user.links;
    return {
        ref: sdk_model_1.uriRef(links.self),
        email: email,
        login: login,
        firstName: firstName,
        lastName: lastName,
        fullName: getUserFullName(firstName, lastName),
    };
};
exports.convertWorkspaceUser = function (user) {
    var getStatusFromState = function (state) {
        switch (state) {
            case "ACTIVE":
                return "ENABLED";
            case "INACTIVE":
                return "DISABLED";
            default:
                return;
        }
    };
    var email = user.email, login = user.login, uri = user.uri, firstName = user.firstName, lastName = user.lastName, state = user.state;
    var status = getStatusFromState(state);
    var statusProp = status ? { status: status } : {};
    return tslib_1.__assign({ ref: sdk_model_1.uriRef(uri), email: email,
        login: login,
        uri: uri, firstName: firstName !== null && firstName !== void 0 ? firstName : undefined, lastName: lastName !== null && lastName !== void 0 ? lastName : undefined, fullName: getUserFullName(firstName, lastName) }, statusProp);
};
exports.convertUsersItem = function (user) {
    var _a = user.content, email = _a.email, login = _a.login, firstname = _a.firstname, lastname = _a.lastname, status = _a.status, links = user.links;
    var statusProp = status ? { status: status } : {};
    return tslib_1.__assign({ ref: sdk_model_1.uriRef(links.self), uri: links.self, email: email, login: login, firstName: firstname, lastName: lastname, fullName: getUserFullName(firstname, lastname) }, statusProp);
};
//# sourceMappingURL=UsersConverter.js.map